import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  CLAIMDOCUMENTS_FEATURE_KEY,
  initialState as claimDocumentsInitialState,
  claimDocumentsReducer
} from './+state/claim-documents.reducer';
import { ClaimDocumentsEffects } from './+state/claim-documents.effects';
import { ClaimDocumentsFacade } from './+state/claim-documents.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(CLAIMDOCUMENTS_FEATURE_KEY, claimDocumentsReducer),
    EffectsModule.forFeature([ClaimDocumentsEffects])
  ],
  providers: [ClaimDocumentsFacade]
})
export class BackOfficeClaimsClaimDocumentsDataAccessClaimDocumentsModule {}
